import React from 'react';
import { Navbar } from '../components/Navbar';
import { TrustBar } from '../components/TrustBar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { EcommerceHero } from '../components/ecommerce-database/EcommerceHero';
import { EcommerceDataPreview } from '../components/ecommerce-database/EcommerceDataPreview';
import { EcommerceWorkflow } from '../components/ecommerce-database/EcommerceWorkflow';
import { EcommerceFields } from '../components/ecommerce-database/EcommerceFields';
import { EcommerceDemo } from '../components/ecommerce-database/EcommerceDemo';
import { EcommerceComparison } from '../components/ecommerce-database/EcommerceComparison';
import { EcommerceUseCases } from '../components/ecommerce-database/EcommerceUseCases';
import { EcommerceFAQ } from '../components/ecommerce-database/EcommerceFAQ';
import { EcommerceCta } from '../components/ecommerce-database/EcommerceCta';
import { DatabaseIcon, SearchIcon, UserIcon, SendIcon, ShieldCheckIcon, MapPinIcon } from 'lucide-react';
const ecommerceFeatures = [{
  title: 'Local business database',
  description: 'Access 200M+ local businesses with verified owner emails and built-in sequencing.',
  href: '#/local-business-database',
  cta: 'Explore database',
  type: 'Feature',
  color: 'blue' as const,
  icon: DatabaseIcon
}, {
  title: 'Owner finder',
  description: 'Find business owner contact info including emails and direct dials.',
  href: '#/owner-finder',
  cta: 'Find owners',
  type: 'Feature',
  color: 'blue' as const,
  icon: UserIcon
}, {
  title: 'Email sequencing',
  description: 'Launch multi-step email campaigns directly from the platform.',
  href: '#/email-sequencing',
  cta: 'Start sequencing',
  type: 'Feature',
  color: 'green' as const,
  icon: SendIcon
}, {
  title: 'Local business enrichment',
  description: 'Enrich your existing business data with verified contacts and firmographics.',
  href: '#/local-business-enrichment',
  cta: 'Enrich data',
  type: 'Feature',
  color: 'blue' as const,
  icon: ShieldCheckIcon
}, {
  title: 'Google Maps scraper',
  description: 'Extract business data from Google Maps at scale.',
  href: '#/google-maps-scraper',
  cta: 'Try scraper',
  type: 'Feature',
  color: 'green' as const,
  icon: MapPinIcon
}, {
  title: 'Browse all databases',
  description: 'Explore 300+ industry databases with verified contact data.',
  href: '#/data',
  cta: 'Browse categories',
  type: 'Database',
  color: 'purple' as const,
  icon: SearchIcon
}];
export function EcommerceDatabase() {
  return <div className="min-h-screen bg-white selection:bg-blue-100 selection:text-blue-900 ecom-aeonik" style={{
    fontFamily: "'Aeonik', system-ui, sans-serif"
  }} data-id="element-6346">
      <Navbar data-id="element-6347" />
      <main data-id="element-6348">
        <EcommerceHero data-id="element-6349" />
        <TrustBar data-id="element-6350" />
        <EcommerceDataPreview data-id="element-6351" />
        <EcommerceWorkflow data-id="element-6352" />
        <EcommerceFields data-id="element-6353" />
        <EcommerceDemo data-id="element-6354" />
        <EcommerceComparison data-id="element-6355" />
        <EcommerceUseCases data-id="element-6356" />
        <EcommerceFAQ data-id="element-6357" />
        <RelatedFeatures features={ecommerceFeatures} data-id="element-6358" />
        <EcommerceCta data-id="element-6359" />
      </main>
      <Footer data-id="element-6360" />
    </div>;
}